<template>
    <div class="input-group input-group-sm">
        <input
            type="search"
            name="table_search"
            :class="['form-control', { 'py-4': big }]"
            placeholder="Buscar"
            v-model="searchValue"
            @input="debouncedEmitInput"
            :disabled="disabled"
        />

        <div class="input-group-append">
            <Button
                data-cy="submit-search"
                type="submit"
                variant="default"
                icon="fas fa-search"
                :disabled="disabled"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: ["value", "disabled", "big"],
        data() {
            return {
                searchValue: this.value,
            };
        },
        created() {
            this.debouncedEmitInput = _.debounce(this.emitInput, 200);
        },
        watch: {
            value(newValue) {
                this.searchValue = newValue;
            },
        },
        methods: {
            emitInput() {
                this.$emit("input", this.searchValue);
            },
        },
    };
</script>